<template>
  <div class="sm-upload-csv">
    <div 
      v-if="status == 'new' || status == ''"
      class="sm-upload-csv__main"
      :class="status"
      @dragenter="dragEnter = true"
      @dragleave="dragEnter = false"
      @dragover.prevent
      @drop="handleDrop"
      @click="$refs['csv-input'].click()"
    >
      <div 
        v-if="dragEnter"
        class="sm-upload-csv__drag"
      >
        <span>Drop file here...</span>  
      </div>
      <template v-else>
        <include-svg :name="'icon-upload-csv'" />
        <p>
          <span>Drag and drop .csv file or </span>
          <a
            href="#"
            class="sm-link"
            @click.prevent
          >upload</a>
        </p>
      </template>
    </div>
    <div 
      v-else-if="status == 'upload'"
      class="sm-upload-csv__main"
      :class="status"
    >
      <include-svg :name="'icon-upload-csv'" />
      <p class="sm-upload-csv__main-flex">
        <text-truncate :text="file.name" />
        <a
          href="#"
          class="sm-grey-link"
          @click.prevent="deleteUpload"
        >Delete</a>
      </p>
    </div>
    <div 
      v-else-if="status == 'error'"
      class="sm-upload-csv__main"
      :class="status"
    >
      <include-svg :name="'icon-upload-error'" />
      <p class="sm-upload-csv__main-flex">
        <span class="sm-error">Upload failed. Upload only .csv file</span>
        <a
          href="#"
          @click.prevent="$refs['csv-input'].click()"
        >Try again</a>
      </p>
    </div>
    <input 
      :ref="['csv-input']"
      hidden 
      type="file" 
      :accept="'.csv'"
      :name="['csv-input']" 
      @change="uploadFile" 
    />
  </div>
</template>

<script>
export default {
  name: 'upload-csv',
  props: {
  },
  data() {
    return {
      status: 'new', // values: new, upload, error
      file: null,
      // maxFileWeight: 25165824,
      dragEnter: false,
      csvMimeTypes: [
        'text/csv',
        'text/plain',
        'application/csv',
        'text/comma-separated-values',
        'application/excel',
        'application/vnd.ms-excel',
        'application/vnd.msexcel',
        'text/anytext',
        'application/octet-stream',
        'application/txt'
      ]
    };
  },
  created() {

  },
  methods: {
    uploadFile(e) {
      if (e.target.files.length === 0) 
        return false;

      const target = e.target;
      this.file = target.files[0];

      this.handleUpload();
    },
    handleUpload() {
      if (
        (this.file.type &&
        this.csvMimeTypes.includes(this.file.type)) ||
        (!this.file.type &&
        this.file.name &&
        this.file.name.substr(this.file.name.length - 4) == '.csv')
      ) {
        this.status = 'upload';

        this.$emit('upload', this.file);
      } else {
        this.status = 'error';
      }
    },
    deleteUpload(e) {
      this.$emit('delete');
      this.status = 'new';
      this.file = null;

      e.stopPropagation();
    },
    handleDrop(e) {
      e.preventDefault();
      this.dragEnter = false;

      if (e.dataTransfer.files.length === 0) 
        return false;

      this.file = e.dataTransfer.files[0];

      this.handleUpload();
    }
  }
}
</script>
